import React, { Component } from "react";
import { getVideoPath, apiReadOneVideo } from "../../../../utils/apis.js"
import Dialog from "../../../dialogs/dialog.js";
import VideoPlayerView from "../../../../components/bases/videoplayer/videoplayerview.js";
import { getlocalhostDatas } from "../../../../utils/apis.js";
import { keyboard_multi_getShorCutList_by_apps_and_keyboard } from "../../../../utils/keyboard_multi.js";




import "./assetsmanager.css"



class DisplayVideo extends Dialog
{
  constructor(props) 
  {
    super(props);

    this.shortcuts_list = [];

    const title = {
        fr:"Lecture : "+this.props.asset.astitle,
        en:"Playing "+this.props.asset.astitle,
      };
    this.state.title = title;
    this.state.videopath = "";
    this.state.videoready = false;

    this.state.buttons = 
    [
      {type:"back", disabled:false},
      
    ]

    this.handleButton =  this.handleButton.bind(this);
    this.apicallback = this.apicallback.bind(this)

    this.onQuit = this.onQuit.bind(this)
    this.videoPlayerRef = React.createRef();

    this.handleKeyDown = this.handleKeyDown.bind(this);
    
  }


componentDidMount()
{
    super.componentDidMount()

    this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["player"]);

    var datas = {viid: this.props.asset.asviid};
    
    apiReadOneVideo (datas, this.apicallback)


    window.addEventListener('keydown', this.handleKeyDown);
}

componentWillUnmount()
{
    window.removeEventListener('keydown', this.handleKeyDown);
}

componentDidUpdate()
{
  
}

handleKeyDown = (event) =>
    {
        if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
          {
            if (this.videoPlayerRef.current.keyboard_multi_gereKeyBoard(this.shortcuts_list, event.key, event.shiftKey, event.ctrlKey, event.altKey))
            {
              event.preventDefault();
              return;
            }
          }
    }



 apicallback(datas)
 {
    

    if (datas.length > 0)
    {
        const video = datas[0];
        
        const videofile = getVideoPath(video);
        

        

        this.setState({videopath: videofile, videoready: true, video: video})
   
    }

 }
  onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
  }

  
  render()
  {
    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 500) maxheight = 500;


    var retour = (
      <div style = {{width:maxwidth, height: maxheight}}>
      </div>
    );

    // src= {this.state.videopath}

    //src= {getlocalhostDatas()+"testhls/master.m3u8"}

    if ((this.props.display) && (this.state.videoready))
    {

        retour =
        (
          <div style = {{width:maxwidth, height: maxheight}}>
            
                <VideoPlayerView 
                  
                  src= {this.state.videopath}
                  ref ={this.videoPlayerRef}
                  video = {this.state.video}
                />

          </div>
        )
      }
    return super.render(retour);
  }


}


export default DisplayVideo;